<panel width="1000">
	<h1>{{ 'invoice-overdue-search.header' | translate }}</h1>

	@if (!debtCollectionReadyInvoices) {
		<section>
			<button #searchButton (click)="search();" [label]="'invoice-overdue-search.search-for-overdue-invoices' | translate"></button>
		</section>
	}

	@if (searching) {
		<skeletons />
	}
	@if (searching) {
		<skeletons [defaultSkeletons]="5" />
	}
	@if (!searching && debtCollectionReadyInvoices) {
		<section>
			<custom-select
				[label]="'invoice-overdue-search.culture-in-export' | translate"
				[selectList]="cultureList"
				[(value)]="selectedCulture"
				[required]="true">
			</custom-select>
		</section>
		<list-view scrollable #overdueInvoicesList>
			<header [sortColumn]="false"><input type="checkbox" (click)="selectAll($event);" /></header>
			<header>{{ 'general.column.company-name' | translate }}</header>
			<header>{{ 'invoice-overdue-search.company-invoice-count' | translate }}</header>
			<header defaultSort="ascending">{{ 'invoice-overdue-search.documentNo' | translate }}</header>
			<header [sortColumn]="false">{{ 'invoice-overdue-search.objection-reason' | translate }}</header>
			<header filterType="contains" [filterValue]="'general.false' | translate">{{ 'invoice-overdue-search.already-in-debt-collection' | translate }}</header>
			<header align-right>{{ 'invoice-overdue-search.remaining-amount' | translate }}</header>
			<header align-right>{{ 'invoice-overdue-search.original-due-date' | translate }}</header>
			<header align-right>{{ 'invoice-overdue-search.due-date' | translate }}</header>
			<row data-id="{{ invoice.documentNo }}" *listData="let invoice from debtCollectionReadyInvoices" (action)="selectCompany(invoice)" [select]="selectedInvoice?.documentNo == invoice.documentNo" (filteredOut)="removeSelectedInvoice(invoice)">
				<column><input type="checkbox" (change)="toggleClickSelect(invoice);" onclick="event.stopPropagation();" [checked]="clickedSelectedInvoices.indexOf(invoice) >= 0" /></column>
				<column>{{ invoice.companyName }}</column>
				<column>{{ invoice.count }}</column>
				<column>{{ invoice.documentNo }}</column>
				<column>{{ invoice.objectionReasonName }}</column>
				<column>{{ 'general.' + invoice.inDebtCollection | translate }}</column>
				<column [sortValue]="invoice.remainingAmountInclVat" align-right>{{ invoice.remainingAmountInclVat | currency }}</column>
				<column [sortValue]="invoice.originalDueDate" align-right>{{ invoice.originalDueDate | customDate: 'shortDate' }}</column>
				<column [sortValue]="invoice.dueDate" align-right>{{ invoice.dueDate | customDate: 'shortDate' }}</column>
			</row>
		</list-view>
		<section>
			<button #exportCsvAndRegisterInvoicesButton
				confirm
				*requiredCredential="debtCollectionRegisterAndExportCredential"
				[active]="clickedSelectedInvoices.length > 0"
				(click)="exportCsvAndRegisterInvoicesForDebtCollection()"
				[label]="'invoice-overdue-search.export-csv-and-register-invoices-for-debt-collection' | translate"
				[labelSaved]="'invoice-overdue-search.export-csv-and-register-invoices-for-debt-collection.complete' | translate"
				[ignoreValidation]="true">
			</button>
			
			<button #exportCsvButton
				[active]="clickedSelectedInvoices.length > 0"
				(click)="exportCsv()"
				[label]="'invoice-overdue-search.export-csv' | translate"
				[labelSaved]="'invoice-overdue-search.export-csv.complete' | translate"
				[ignoreValidation]="true">
			</button>
		</section>
	}
</panel>

@if (selectedInvoice) {
	<panel width="420">
		<h1>{{ 'company-invoices.billing-information' | translate }}</h1>
		@if (!company || !billingInfo) {
			<skeletons [defaultSkeletons]="5" />
		}
		@if (company && billingInfo) {
			<company-information [company]="company" [billingInfo]="billingInfo" />
			<list-contact [company]="company" [showJustDefaultContactForBilling]="true" />
		}
	</panel>
}
